// extracted by mini-css-extract-plugin
export default {"container":"kO-z","topReviewHeading":"lO-z","criticalReview":"mO-z","favorableReview":"nO-z","vsSeparator":"oO-z"};